/* Lumibrace product section JS — iOS/TikTok-safe direct add-to-cart */
(function () {
  'use strict';

  try {
    var galleryMain = document.getElementById('gallery-main');
    var ctaBtn      = document.getElementById('cta-buy');
    if (!galleryMain && !ctaBtn) return;

    function syncBuyForm() {
      if (!buyForm) return;
      try {
        var variant = findVariantObj && findVariantObj();
        if (variant) {
          var idInput = buyForm.querySelector('input[name="id"]');
          if (idInput) idInput.value = String(variant.id);
        }
        Array.prototype.slice.call(buyForm.querySelectorAll('[data-dyn]')).forEach(function (n) { n.remove(); });
        if (state.bundle === 'pair') {
          function addField(name, value) {
            var i = document.createElement('input');
            i.type = 'hidden'; i.name = name; i.value = value;
            i.setAttribute('data-dyn', '1');
            buyForm.appendChild(i);
          }
          addField('properties[צבע צמיד 1]', colorLabel(state.color1));
          addField('properties[צבע צמיד 2]', colorLabel(state.color2));
        }
      } catch (e) { console.warn('[lumi] syncBuyForm failed', e); }
    }

    // ---------- Variants ----------
    var variantData = null;
    var variantScript = document.getElementById('lumibrace-variants');
    if (variantScript) {
      try { variantData = JSON.parse(variantScript.textContent); }
      catch (e) { console.error('[lumi] variant JSON parse failed', e); variantData = null; }
    }

    var state = {
      bundle: 'single',   // single | pair
      color1: 'gold',     // gold | silver
      color2: 'gold'
    };

    // ---------- Gallery ----------
    var galleryImgs = document.querySelectorAll('.gallery-imgs .gallery-image');
    var counterEl   = document.getElementById('gallery-counter');
    var prevBtn     = document.getElementById('gallery-prev');
    var nextBtn     = document.getElementById('gallery-next');
    var thumbsWrap  = document.getElementById('gallery-thumbs');
    var currentIdx  = 0;
    var THUMB_WINDOW = 5;
    var AUTOPLAY_MS  = 5000;
    var autoTimer    = null;
    var autoPaused   = false;
    var autoVisible  = true;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function orderedImages(color) {
      var primary = [], rest = [];
      galleryImgs.forEach(function (img) {
        if (img.dataset.color === color) primary.push(img);
        else rest.push(img);
      });
      var all = primary.concat(rest);
      if (!all.length) all = Array.prototype.slice.call(galleryImgs);
      return all;
    }

    function thumbStart(total) {
      if (total <= THUMB_WINDOW) return 0;
      var half = Math.floor(THUMB_WINDOW / 2);
      var start = currentIdx - half;
      if (start < 0) start = 0;
      if (start > total - THUMB_WINDOW) start = total - THUMB_WINDOW;
      return start;
    }

    function renderThumbs(imgs) {
      if (!thumbsWrap) return;
      var start  = thumbStart(imgs.length);
      var thumbs = imgs.slice(start, start + THUMB_WINDOW);
      var key    = state.color1 + ':' + start;

      if (thumbsWrap.dataset.key !== key) {
        thumbsWrap.dataset.key = key;
        thumbsWrap.innerHTML = '';
        thumbs.forEach(function (img, i) {
          var absIdx = start + i;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'gallery-thumb';
          b.setAttribute('aria-label', 'תמונה ' + (absIdx + 1));
          var t = document.createElement('img');
          t.src = img.currentSrc || img.src;
          t.alt = img.alt || '';
          t.loading = 'lazy';
          b.appendChild(t);
          b.addEventListener('click', function () { goTo(absIdx, true); });
          b.addEventListener('mouseenter', function () { if (currentIdx !== absIdx) goTo(absIdx, true); });
          b.addEventListener('focus', function () { if (currentIdx !== absIdx) goTo(absIdx, true); });
          thumbsWrap.appendChild(b);
        });
        if (!reduceMotion) {
          thumbsWrap.classList.remove('is-swap');
          void thumbsWrap.offsetWidth;
          thumbsWrap.classList.add('is-swap');
        }
      }

      Array.prototype.slice.call(thumbsWrap.children).forEach(function (b, i) {
        b.classList.toggle('active', (start + i) === currentIdx);
      });
    }

    function renderGallery() {
      var imgs = orderedImages(state.color1);
      if (currentIdx >= imgs.length) currentIdx = 0;
      galleryImgs.forEach(function (img) { img.hidden = true; });
      imgs.forEach(function (img, i) { img.hidden = (i !== currentIdx); });
      var wrap = document.getElementById('gallery-main');
      if (wrap) { wrap.classList.remove('is-swap'); void wrap.offsetWidth; wrap.classList.add('is-swap'); }
      if (counterEl) counterEl.textContent = (currentIdx + 1) + ' / ' + imgs.length;
      renderThumbs(imgs);
    }

    function goTo(idx, userAction) {
      var imgs = orderedImages(state.color1);
      if (!imgs.length) return;
      currentIdx = ((idx % imgs.length) + imgs.length) % imgs.length;
      renderGallery();
      if (userAction) restartAutoplay();
    }

    function advance() {
      var imgs = orderedImages(state.color1);
      if (!imgs.length) return;
      goTo(currentIdx + 1, false);
    }

    function stopAutoplay() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    function startAutoplay() {
      stopAutoplay();
      return; // autoplay disabled
      if (reduceMotion || autoPaused || !autoVisible) return;
      var imgs = orderedImages(state.color1);
      if (imgs.length < 2) return;
      autoTimer = setInterval(advance, AUTOPLAY_MS);
    }

    function restartAutoplay() { startAutoplay(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIdx - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIdx + 1, true); });

    if (galleryMain) {
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        galleryMain.addEventListener(ev, function () { autoPaused = true; stopAutoplay(); }, { passive: true });
      });
      ['mouseleave', 'focusout', 'touchend', 'touchcancel'].forEach(function (ev) {
        galleryMain.addEventListener(ev, function () { autoPaused = false; startAutoplay(); }, { passive: true });
      });
      if (thumbsWrap) {
        thumbsWrap.addEventListener('mouseenter', function () { autoPaused = true; stopAutoplay(); });
        thumbsWrap.addEventListener('mouseleave', function () { autoPaused = false; startAutoplay(); });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          autoVisible = entries[0].isIntersecting;
          if (autoVisible) startAutoplay(); else stopAutoplay();
        }, { threshold: 0.15 }).observe(galleryMain);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay(); else startAutoplay();
      });
      startAutoplay();
    }

    // ---------- Color cards (Step 1) ----------
    var step1Colors = document.querySelectorAll('.color-card[data-color]:not([data-pair]):not([data-pcm])');
    step1Colors.forEach(function (card) {
      card.addEventListener('click', function () {
        state.color1 = card.dataset.color;
        step1Colors.forEach(function (c) {
          c.setAttribute('aria-checked', c === card ? 'true' : 'false');
          c.classList.toggle('active', c === card);
        });
        currentIdx = 0;
        renderGallery();
        restartAutoplay();
        syncBuyForm();
      });
    });

    // ---------- Pair color cards (Step 2 in-page) ----------
    document.querySelectorAll('.color-card[data-pair]').forEach(function (card) {
      card.addEventListener('click', function () {
        var val = card.dataset.color;
        if (card.dataset.pair === '1') state.color1 = val; else state.color2 = val;
        var siblings = document.querySelectorAll('.color-card[data-pair="' + card.dataset.pair + '"]');
        siblings.forEach(function (c) {
          c.setAttribute('aria-checked', c === card ? 'true' : 'false');
          c.classList.toggle('active', c === card);
        });
        syncBuyForm();
      });
    });

    // ---------- Bundle (single / pair) ----------
    var bundleCards = document.querySelectorAll('[data-bundle]');
    var pairBlock   = document.getElementById('pair-customize');
    var trustShip   = document.getElementById('trust-shipping');
    var ctaText     = document.getElementById('cta-text');

    function applyBundle() {
      bundleCards.forEach(function (c) {
        var on = c.dataset.bundle === state.bundle;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.classList.toggle('active', on);
      });
      if (pairBlock) {
        if (state.bundle === 'pair') {
          pairBlock.style.display = '';
          pairBlock.classList.add('open');
        } else {
          pairBlock.classList.remove('open');
          pairBlock.style.display = 'none';
        }
      }
      var LBP = (window.theme && window.theme.prices) || {};
      if (state.bundle === 'pair') {
        if (trustShip)  trustShip.textContent  = 'משלוח חינם';
        if (ctaText)    ctaText.textContent    = 'לחצו להוספה לעגלה ב-' + (LBP.pctPair || 40) + '% הנחה';
      } else {
        if (trustShip)  trustShip.textContent  = 'משלוח חינם';
        if (ctaText)    ctaText.textContent    = 'לחצו להוספה לעגלה ב-' + (LBP.pctSingle || 30) + '% הנחה';
      }
    }
    bundleCards.forEach(function (c) {
      c.addEventListener('click', function () {
        var prev = state.bundle;
        state.bundle = c.dataset.bundle;
        applyBundle();
        syncBuyForm();
        if (state.bundle === 'pair' && prev !== 'pair' && pairBlock) {
          try {
            requestAnimationFrame(function () {
              pairBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          } catch (_) {}
        }
      });
    });
    if (pairBlock) pairBlock.style.display = 'none';
    applyBundle();

    // Allow external CTAs (e.g. gift-cta section) to select the pair bundle.
    document.addEventListener('lumibrace:select-pair-bundle', function () {
      if (state.bundle === 'pair') {
        var pairCard = document.querySelector('[data-bundle="pair"]');
        if (pairCard && pairBlock) {
          requestAnimationFrame(function () { pairBlock.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
        }
        return;
      }
      state.bundle = 'pair';
      applyBundle();
      syncBuyForm();
      if (pairBlock) {
        try {
          requestAnimationFrame(function () { pairBlock.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
        } catch (_) {}
      }
      // No pairCard.click() here: applyBundle() already set the UI state, and the
      // synthetic click re-ran the whole handler (double work, no user benefit).
    });

    // ---------- Variant resolution ----------
    function findVariantObj() {
      if (!variantData || !variantData.variants || !variantData.variants.length) return null;
      var packTokens = state.bundle === 'pair'
        ? ['זוג', 'pair']
        : ['בודד', 'single'];
      var sameColor = state.color1 === state.color2;
      var colorTokens;
      if (state.bundle === 'pair' && !sameColor) {
        colorTokens = ['מעורב', 'mix'];
      } else {
        colorTokens = state.color1 === 'silver'
          ? ['כסף', 'silver', 'כסוף', 'silver-tone']
          : ['זהב', 'gold', 'זהוב', 'gold-tone'];
      }
      function hasToken(opts, tokens) {
        return opts.some(function (o) {
          return tokens.some(function (t) { return o.indexOf(t) !== -1; });
        });
      }
      var found = variantData.variants.find(function (v) {
        var opts = (v.options || []).map(function (o) { return String(o).trim().toLowerCase(); });
        return hasToken(opts, packTokens) && hasToken(opts, colorTokens);
      });
      if (!found) {
        // Only fall back when it is unambiguous (exactly one variant for this pack).
        // Never guess a different color/pack — that would put the wrong item in the cart.
        var packOnly = variantData.variants.filter(function (v) {
          var opts = (v.options || []).map(function (o) { return String(o).trim().toLowerCase(); });
          return hasToken(opts, packTokens);
        });
        if (packOnly.length === 1) found = packOnly[0];
        else if (variantData.variants.length === 1) found = variantData.variants[0];
      }
      return found || null;
    }

    function colorLabel(c) { return (c === 'silver' || c === 'כסף') ? 'כסף' : 'זהב'; }

    // ---------- Add to cart ----------
    var ctaSpinner = document.getElementById('cta-spinner');
    var buyForm    = document.getElementById('lumi-buy-form');

    function setLoading(on) {
      if (ctaBtn)     ctaBtn.disabled = !!on;
      if (ctaSpinner) ctaSpinner.style.display = on ? '' : 'none';
    }

    // GA4 only. Meta/TikTok get the add-to-cart from Shopify Customer Events,
    // which Shopify publishes automatically for every /cart/add.js call.
    function fireAnalytics(variant) {
      try {
        if (window.Lumi && window.Lumi.track) window.Lumi.track.addToCart(variant, 1);
      } catch (e) { console.warn('[lumi] analytics push failed', e); }
    }

    // Fallback: native multipart POST to /cart/add with return_to=/cart.
    // (Cart permalinks /cart/{id}:1 always jump straight to checkout and drop
    // the photo + line-item properties, so they must never be used here.)
    function nativeSubmitToCart(variant) {
      if (!buyForm) return false;
      try {
        syncBuyForm();
        var idInput = buyForm.querySelector('input[name="id"]');
        if (idInput && variant && variant.id) idInput.value = String(variant.id);
        var single = document.getElementById('lumi-photo-input');
        var p1 = document.getElementById('lumi-pair-photo-1');
        var p2 = document.getElementById('lumi-pair-photo-2');
        var isPair = state.bundle === 'pair';
        [[single, !isPair], [p1, isPair], [p2, isPair]].forEach(function (x) {
          var el = x[0]; if (!el) return;
          // Skip inputs of the inactive bundle and empty file fields.
          el.disabled = !(x[1] && el.files && el.files.length > 0);
        });
        var rt = buyForm.querySelector('input[name="return_to"]');
        if (rt) rt.value = '/cart';
        HTMLFormElement.prototype.submit.call(buyForm);
        return true;
      } catch (e) { console.error('[lumi] native submit failed', e); return false; }
    }

    // NOTE: we deliberately do NOT call Shopify.analytics.publish('product_added_to_cart').
    // Shopify's Ajax Cart API emits that standard event by itself on /cart/add.js.
    // Publishing it manually produced two AddToCart events in Meta.


    // AJAX add-to-cart — fires Shopify's cart events that analytics listens to,
    // and (critically) avoids a cross-context POST→302 that Meta/IG/TikTok
    // WebViews intercept with an "open in browser" interstitial.
    function getPhotoFile() {
      var input = document.getElementById('lumi-photo-input');
      if (input && input.files && input.files.length > 0) return input.files[0];
      return null;
    }

    function getPairFile(n) {
      var input = document.getElementById('lumi-pair-photo-' + n);
      if (input && input.files && input.files.length > 0) return input.files[0];
      return null;
    }

    function fetchWithTimeout(url, opts, ms) {
      if (typeof AbortController === 'undefined') return fetch(url, opts);
      var ctrl = new AbortController();
      var t = setTimeout(function () { ctrl.abort(); }, ms);
      opts.signal = ctrl.signal;
      return fetch(url, opts).then(function (r) { clearTimeout(t); return r; },
        function (e) { clearTimeout(t); throw e; });
    }

    function ajaxAddToCart(variant) {
      var props = null;
      if (state.bundle === 'pair') {
        props = {
          'צבע צמיד 1': colorLabel(state.color1),
          'צבע צמיד 2': colorLabel(state.color2)
        };
      }
      // Only send the photo inputs that belong to the CURRENT bundle. A shopper who
      // uploads a single photo and then switches to the pair used to send all three
      // properties on one line (duplicate/extra data in Shopify + Meta).
      var file  = state.bundle === 'pair' ? null : getPhotoFile();
      var pair1 = state.bundle === 'pair' ? getPairFile(1) : null;
      var pair2 = state.bundle === 'pair' ? getPairFile(2) : null;
      var hasAnyFile = !!(file || pair1 || pair2);

      // If any file is selected, send as multipart FormData.
      if (hasAnyFile) {
        var fd = new FormData();
        fd.append('id', variant.id);
        fd.append('quantity', '1');
        if (props) {
          Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
        }
        if (file)  fd.append('properties[תמונה לבחירה]', file, file.name);
        if (pair1) fd.append('properties[תמונה לצמיד 1]', pair1, pair1.name);
        if (pair2) fd.append('properties[תמונה לצמיד 2]', pair2, pair2.name);
        return fetchWithTimeout('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: fd
        }, 30000).then(function (r) {
          if (!r.ok) throw new Error('cart/add.js ' + r.status);
          return r.json();
        });
      }

      // No file — JSON path (faster, cleaner).
      var body = { id: variant.id, quantity: 1 };
      if (props) body.properties = props;
      return fetchWithTimeout('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }, 20000).then(function (r) {
        if (!r.ok) throw new Error('cart/add.js ' + r.status);
        return r.json();
      });
    }

    // Show selected filename + size guard
    (function () {
      var input = document.getElementById('lumi-photo-input');
      var nameEl = document.getElementById('lumi-photo-name');
      var btnText = document.getElementById('lumi-photo-btn-text');
      if (!input) return;
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        if (!f) { if (nameEl) { nameEl.hidden = true; nameEl.textContent = ''; } return; }
        if (f.size > 15 * 1024 * 1024) {
          alert('הקובץ גדול מדי (מקסימום 15MB). בחרו תמונה קטנה יותר או סיימו את ההזמנה ושלחו לנו את התמונה דרך עמוד צור קשר.');
          input.value = '';
          return;
        }
        if (nameEl) {
          nameEl.textContent = '✓ נבחר: ' + f.name;
          nameEl.hidden = false;
        }
        if (btnText) btnText.textContent = 'החליפו תמונה';
      });
    })();


    // AJAX add-to-cart, then navigate to /cart. Works inside the Shopify theme editor
    // (which blocks cross-route POST redirects) and on the live storefront.
    //
    // We build the payload with ajaxAddToCart() instead of FormData(buyForm) on purpose:
    // the form owns all three file inputs, so a raw FormData shipped the inactive
    // bundle's photos and empty file fields as line-item properties.
    if (buyForm) {
      var addInFlight = false;
      buyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addInFlight) return; // double-tap guard: one add per click
        try { syncBuyForm(); } catch (_) {}

        var variant = null;
        try { variant = findVariantObj && findVariantObj(); } catch (_) {}
        if (!variant) {
          alert('האפשרות שבחרתם אינה זמינה כרגע. נסו צבע/סוג אחר או פנו אלינו דרך עמוד צור קשר.');
          return;
        }

        addInFlight = true;
        setLoading(true);

        // Photo attached → /cart/add.js can't carry raw files reliably.
        // Go straight through Shopify's native form POST, which lands on /cart.
        var hasPhoto = state.bundle === 'pair'
          ? !!(getPairFile(1) || getPairFile(2))
          : !!getPhotoFile();
        // Wait for photo-safe.js to finish shrinking the photo, then upload it in the
        // background via /cart/add.js (multipart). The old full-page form POST took
        // 15s+ inside Meta/IG WebViews; it now only runs as a fallback.
        var ready = Promise.resolve();
        if (hasPhoto) {
          var ids = state.bundle === 'pair' ? ['lumi-pair-photo-1','lumi-pair-photo-2'] : ['lumi-photo-input'];
          ready = Promise.all(ids.map(function (id) {
            var el = document.getElementById(id);
            return el && el.__lumiReady ? el.__lumiReady.catch(function(){}) : null;
          }));
        }

        ready.then(function () { return ajaxAddToCart(variant); })
          .catch(function (err) {
            // One retry — first visit sometimes fails before the cart session exists.
            console.warn('[lumi] add to cart failed, retrying', err);
            return new Promise(function (res) { setTimeout(res, 600); })
              .then(function () { return ajaxAddToCart(variant); });
          })
          .then(function () {
            fireAnalytics(variant);
            try { window.location.href = '/cart'; }
            catch (_) { window.location.assign('/cart'); }
          })
          .catch(function (err) {
            console.error('[lumi] add to cart failed', err);
            // Fallback: regular form POST to /cart/add → lands on /cart (never checkout).
            if (nativeSubmitToCart(variant)) return;
            addInFlight = false;
            setLoading(false);
            alert('לא ניתן להוסיף לסל כרגע. נסו שוב או פתחו את הקישור בדפדפן Safari/Chrome.');
          });
      });
    }

    // Back button (iOS Safari / in-app browsers restore the page from cache):
    // the button stayed disabled with a spinner and every further tap was ignored.
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) { addInFlight = false; setLoading(false);
        ['lumi-photo-input','lumi-pair-photo-1','lumi-pair-photo-2'].forEach(function (id) {
          var el = document.getElementById(id); if (el) el.disabled = false; });
      }
    });

    // Keep modal helpers exposed (other snippets may rely on them).
    function openModal(id) {
      var m = document.getElementById(id);
      if (!m) return;
      m.classList.add('open');
      if (window.LumiBody) window.LumiBody.lock(); else document.body.style.overflow = 'hidden';
    }
    function closeModal(id) {
      var m = (typeof id === 'string') ? document.getElementById(id) : id;
      if (!m) return;
      m.classList.remove('open');
      if (window.LumiBody) window.LumiBody.unlock(); else document.body.style.overflow = '';
    }
    window.LumiModal = { open: openModal, close: closeModal };
    document.addEventListener('click', function (e) {
      var closer = e.target.closest && e.target.closest('[data-close]');
      if (closer) {
        var m = closer.closest('.modal-root');
        if (m) { e.preventDefault(); closeModal(m); }
      }
    });



    // ---------- Pair photo uploads (per-bracelet) ----------
    [1, 2].forEach(function (n) {
      var input  = document.getElementById('lumi-pair-photo-' + n);
      var nameEl = document.getElementById('lumi-pair-photo-' + n + '-name');
      var btnTxt = document.getElementById('lumi-pair-photo-' + n + '-text');
      var rmBtn  = document.querySelector('[data-pair-remove="' + n + '"]');
      if (!input) return;
      function reset() {
        try { input.value = ''; } catch (_) {}
        if (nameEl) { nameEl.textContent = ''; nameEl.hidden = true; }
        if (btnTxt) btnTxt.textContent = 'העלו תמונה לצמיד ' + n;
        if (rmBtn)  rmBtn.hidden = true;
      }
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        if (!f) { reset(); return; }
        if (f.size > 15 * 1024 * 1024) {
          alert('הקובץ גדול מדי (מקסימום 15MB). נסו תמונה קטנה יותר.');
          reset();
          return;
        }
        if (nameEl) { nameEl.textContent = f.name; nameEl.hidden = false; }
        if (btnTxt) btnTxt.textContent = 'תמונה נבחרה — לחצו להחלפה';
        if (rmBtn)  rmBtn.hidden = false;
      });
      if (rmBtn) rmBtn.addEventListener('click', function (e) { e.preventDefault(); reset(); });
    });

    // initial render
    renderGallery();
    syncBuyForm();

    // ---------- ViewContent for the One-Page setup ----------
    // On a One Page site Shopify never fires `product_viewed` by itself (it only
    // does on /products/<handle>), so the "Facebook & Instagram" app has no
    // ViewContent to forward. We publish it ourselves, ONCE per session, as soon
    // as the page is ready — no scroll required, and the session flag is only
    // written after Shopify.analytics actually accepted the event.
    (function publishViewContent(){
      try {
        var variant = null;
        try { variant = findVariantObj && findVariantObj(); } catch (_) {}
        if (!variant && variantData && variantData.variants && variantData.variants.length) {
          variant = variantData.variants[0];
        }
        if (!variant) return;

        var priceNum = parseFloat(String(variant.price).replace(/[^\d.]/g, '')) || 0;
        var pTitle   = (variantData && variantData.productTitle) || 'LumiBrace';
        var payload = {
          productVariant: {
            id: 'gid://shopify/ProductVariant/' + variant.id,
            price: { amount: priceNum, currencyCode: (variantData && variantData.currency) || 'ILS' },
            sku: variant.sku || '',
            product: {
              id: 'gid://shopify/Product/' + (variantData && variantData.productId ? variantData.productId : variant.id),
              title: pTitle,
              untranslatedTitle: pTitle,
              vendor: (variantData && variantData.productVendor) || 'LumiBrace',
              type: (variantData && variantData.productType) || '',
              url: '/products/' + ((variantData && variantData.productHandle) || 'lumibrace')
            },
            title: variant.title || '',
            untranslatedTitle: variant.title || '',
            image: null
          }
        };

        if (window.Lumi && window.Lumi.track) {
          // On a real /products/<handle> page Shopify publishes product_viewed itself,
          // so publishing again sent TWO ViewContent events to Meta. Only publish the
          // manual one when this section is rendered outside the product template.
          var isProductTemplate = !!(window.theme && window.theme.template === 'product');
          if (!isProductTemplate) {
            window.Lumi.track.publishOnce('lumi_view_content_fired', 'product_viewed', payload);
          }
          // GA4 view_item is ours in both cases (it is de-duplicated by once()).
          window.Lumi.track.viewItem(variant);
        }
      } catch (e) { console.warn('[lumi] ViewContent failed', e); }
    })();

  } catch (initErr) {
    console.error('[lumi] init failed', initErr);
  }
})();
